export default "__VITE_ASSET__dXiauubj__"